'use strict';

var _ajax = require('./ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _util = require('./util/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var service = {
    getLoginStatus: function getLoginStatus(success, error) {
        _ajax2["default"].request({
            url: _util.config.url.getLoginStatus,
            success: success,
            error: error
        });
    },
    getVerifyCode: function getVerifyCode(params, success, error) {
        _ajax2["default"].request({
            url: _util.config.url.getVerifyCode + '&params=' + JSON.stringify(params),
            success: success,
            error: error
        });
    },
    getBookingInfo: function getBookingInfo(success, error) {
        _ajax2["default"].request({
            url: _util.config.url.getBookingInfo,
            success: success,
            error: error
        });
    },
    doBooking: function doBooking(params, success, error) {
        _ajax2["default"].request({
            url: _util.config.url.doBooking + '&params=' + JSON.stringify(params),
            success: success,
            error: error
        });
    },
    getGifts: function getGifts(params, success, error) {
        _ajax2["default"].request({
            url: _util.config.url.getGifts + '&params=' + JSON.stringify(params),
            success: success,
            error: error
        });
    },
    getParam: function getParam(success, error) {
        _ajax2["default"].request({
            url: _util.config.url.getParam,
            success: success,
            error: error
        });
    },
    share: function share(success, error) {
        _ajax2["default"].request({
            url: _util.config.url.share,
            success: success,
            error: error
        });
    }
};
module.exports = service;


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/service.js
// module id = 34
// module chunks = 7 8